// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 37) return "static/chunks/37-3e60a76c5080f1ba.js";
	if (chunkId === 8386) return "static/chunks/8386-a178dde3735863cf.js";
	if (chunkId === 8015) return "static/chunks/8015-8b1afcfa59e73023.js";
	if (chunkId === 2460) return "static/chunks/2460-df2c7eb564094932.js";
	if (chunkId === 9427) return "static/chunks/9427-c8d8c674e68bef2b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2545":"c16f53c3","9871":"d677e29b"}[chunkId] || chunkId) + "." + {"1107":"8d6cdaf50d7f6489","2545":"40a521d8cd71c215","2780":"fa01f693a0b55cc0","5011":"2ec99af48f0fe3c9","6757":"a7ef094b594479b5","8123":"cb40f2e6194624f2","9863":"a407f785800fba42","9871":"d3e55955c0650ded"}[chunkId] + ".js";
};